import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Record } from '../../../../models/record';
import { BaseDropdownOptionsButtonComponent } from '../../../base-dropdown-options-button/base-dropdown-options-button.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-swiper-more-button',
  templateUrl: './swiper-more-button.component.html',
  styleUrls: ['./swiper-more-button.component.scss']
})
export class SwiperMoreButtonComponent extends BaseDropdownOptionsButtonComponent implements OnInit, OnDestroy {
  @Input() record: Record;

  private favoriteAddedSubscription: Subscription;
  private favoriteRemovedSubscription: Subscription;

  ngOnInit(): void {
    super.record = this.record;
    this.checkout = this.checkoutsFacade.getCheckoutByRecordId(this.record.id, this.issueDate, this.rhId);

    this.showReturnLoanButton = this.configService.get().showReturnLoanButton;
    this.isCheckedOut = this.checkIsCheckedOut();

    this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;

    this.favoriteFacade.favoriteAdded$.subscribe((favoriteAdded) => {
      if (favoriteAdded?.recordId === this.record.id) {
        this.alreadyInFavorites = true;
        this.favoriteIcon = 'favorite_black';
        this.favoriteText = 'tooltip.removeFromFavorites';
      }
    });

    this.favoriteFacade.favoriteRemoved$.subscribe((favoriteRemoved) => {
      if (favoriteRemoved?.recordId === this.record.id) {
        this.alreadyInFavorites = false;
        this.favoriteIcon = 'favorite';
        this.favoriteText = 'tooltip.addToFavorites';
      }
    });

    this.alreadyInFavorites = this.favoriteFacade.getFavoriteByRecordId(this.record.id) !== undefined;
    this.favoriteIcon = this.alreadyInFavorites ? 'favorite_black' : 'favorite';
    this.favoriteText = this.alreadyInFavorites ? 'tooltip.removeFromFavorites' : 'tooltip.addToFavorites';

    this.showShareButtons = this.configService.get().showSocialIcons;
    this.socialButtons = this.configService.shareIcons;
    this.shareText = this.localeService.getLocalizedShareText(this.record, this.configService.get().title);
    this.showReportIssueButton = (this.authService.getLoggedUser() && (this.configService.get().showReportIssueButton === undefined) ? true : this.configService.get().showReportIssueButton);
  }

  ngOnDestroy(): void {
    this.favoriteAddedSubscription?.unsubscribe();
    this.favoriteRemovedSubscription?.unsubscribe();
  }
}
